import { defineRecipe } from '@chakra-ui/react';

export const checkmarkRecipe = defineRecipe({
  className: 'chakra-checkmark',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0',
    borderWidth: '2px',
    color: 'neutral.500',
    borderColor: 'neutral.500',
    borderRadius: 'none',
    backgroundColor: 'transparent',
    boxSize: '20px',
    cursor: 'pointer',
    _icon: {
      width: '100%',
      height: '100%',
    },
    _hover: {
      backgroundColor: 'blue.600',
      borderColor: 'skyblue',
    },
    '&&:is([data-state=checked], [data-state=indeterminate])': {
      color: 'neutral.white',
      backgroundColor: 'blue.700',
      borderColor: 'blue',
      _hover: {
        color: 'skyBlue',
        backgroundColor: 'blue.600',
        borderColor: 'skyBlue',
      },
    },
    '&&:is([data-readonly])': {
      cursor: 'default',
      color: 'neutral.500',
      backgroundColor: 'neutral.800',
      borderColor: 'neutral.500',
      _hover: {
        cursor: 'default',
        color: 'neutral.500',
        backgroundColor: 'neutral.800',
        borderColor: 'neutral.500',
      },
    },
    _disabled: {
      cursor: 'default',
      color: 'neutral.600',
      backgroundColor: 'neutral.600',
      borderColor: 'neutral.600',
    },
  },
});
